import { jsxs, jsx } from 'react/jsx-runtime';
import { useControllableState } from '@radix-ui/react-use-controllable-state';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { useState } from 'react';
import { FileUploadDropOverlay } from './components/drop-overlay/DropOverlay.mjs';
import { FileUploadDropZone } from './components/drop-zone/DropZone.mjs';
import { FileUploadFileList } from './components/file-list/FileList.mjs';
import { FileUploadTrigger } from './components/trigger/Trigger.mjs';
import { FileUploadProvider } from './context.mjs';
import { getFilesFromEvent } from './utils/getFilesFromEvent.mjs';

function FileUpload({
  children,
  id,
  name,
  accept,
  files: filesFromProps,
  defaultFiles: defaultFilesFromProps,
  onFilesChange,
  disabled = false,
  multiple = false,
  droppable = true
}) {
  const [files = [], setFiles] = useControllableState({
    prop: filesFromProps,
    defaultProp: defaultFilesFromProps,
    onChange: onFilesChange
  });
  const [dragging, setDragging] = useState(false);
  const [inputElement, setInputElement] = useState(
    null
  );
  const handleChange = (event) => setFiles(getFilesFromEvent(event));
  const handleClick = (event) => {
    event.stopPropagation();
    event.currentTarget.value = "";
  };
  return /* @__PURE__ */ jsxs(
    FileUploadProvider,
    {
      disabled,
      dragging,
      droppable,
      multiple,
      files,
      inputElement,
      onDraggingChange: setDragging,
      onFilesChange: setFiles,
      children: [
        children,
        /* @__PURE__ */ jsx(VisuallyHidden, { asChild: true, children: /* @__PURE__ */ jsx(
          "input",
          {
            type: "file",
            tabIndex: -1,
            id,
            name,
            accept,
            multiple,
            onChange: handleChange,
            onClick: handleClick,
            ref: setInputElement
          }
        ) })
      ]
    }
  );
}
FileUpload.displayName = "FileUpload";
FileUpload.Trigger = FileUploadTrigger;
FileUpload.DropZone = FileUploadDropZone;
FileUpload.DropOverlay = FileUploadDropOverlay;
FileUpload.FileList = FileUploadFileList;

export { FileUpload };
//# sourceMappingURL=FileUpload.mjs.map
